
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface PermissionLoadErrorProps {
  onRetry: () => void;
  onContinue?: () => void;
  error?: string;
}

export const PermissionLoadError: React.FC<PermissionLoadErrorProps> = ({
  onRetry,
  onContinue,
  error,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-64 space-y-4">
      <Alert className="max-w-md" variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Permission Loading Timeout</AlertTitle>
        <AlertDescription>
          {error || 'Unable to load your permissions. This may be due to a network issue or server timeout.'}
        </AlertDescription>
      </Alert>
      <div className="flex gap-2">
        <Button onClick={onRetry} variant="default">
          <RefreshCw className="h-4 w-4 mr-2" />
          Retry
        </Button>
        {onContinue && (
          <Button onClick={onContinue} variant="outline">
            Continue Anyway
          </Button>
        )}
      </div>
    </div>
  );
};
